// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex-container {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-evenly;
}

.flex-container-bottom {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-evenly;
}

.flex-container-bottom > .flex-child > label{
  margin-right: 5px;
}

.flex-child-long {
  flex-grow: 12;
}

.flex-child-long > input {
  width: 100%;
}

.modal-body {
  background-color: #FFFFFF;
}

.p-tabview.ui-tabview-top .form-group.search {
  margin-bottom: 24px;
}

input::placeholder {
  /*sets the line height to 3 times the font size. The line height is the vertical space between lines of text.*/
  font: 1.5rem/3 sans-serif;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100% - 1rem);
}

.modal-content {
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 0 !important;
  border: none;
  width: 190%;
  max-width: 10000px;
}

.modal-dialog {
  width: 50%;
  max-width: 60%;
  margin: 1.75rem auto;
}

.modal-content {
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 0 !important;
  border: none;
  width: 100%; /* Assurez-vous que le contenu prend toute la largeur disponible */
}

.modal-body {
  background-color: #FFFFFF;
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
}

.modal-header {
  border-bottom: none;
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 0;
  padding-left: 24px;
}

.modal-footer {
  border-top: none;
  padding: 7px;
}

.modal-footer button {
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  width: auto;
}

.modal-footer button.pull-left {
  padding-left: 5px;
  padding-right: 5px;
  position: relative;
  left: -5px;
}

.modal-footer button + button {
  margin-bottom: 16px;
}

.modal-body + .modal-footer {
  padding-top: 0;
}

/* Style the select box */
select {
  width: 100%; /* Make the select box full-width */
  padding: 10px; /* Add padding for better touch interaction */
  font-size: 16px; /* Adjust font size as needed */
}

/* Style the dropdown arrow icon (optional) */
select::-ms-expand {
  display: none; /* Remove the default arrow icon in IE */
}
select::-webkit-select-arrow {
  display: none; /* Remove the default arrow icon in Chrome and Safari */
}

/* Style the options */
select option {
  font-size: 14px; /* Adjust font size as needed */
}

/* Buttons */
.btnAdminManage {
  display: inline-block;
  padding: 9px 12px;
  padding-top: 7px;
  margin-bottom: 0;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-color: #d1dade;
  background-image: none !important;
  border: none;
  text-shadow: none;
  box-shadow: none;
  transition: all 0.12s linear 0s !important;
  width: 100%;
}

.btn-raised {
  margin-right: 5px;
  min-width: 120px;
  margin-bottom: 8px;
}

.btn.btn-save {
  background-color: #4cae4c;
  color: #ffffff;
}

.btn.btn-save:hover, .btn.btn-save:focus {
	background-color: #5cb85c;
}

.btn-cons, .btnAdminManage {
  background-color: #0077B5;
  color: #ffffff;
}

.btn.btn-cons:hover, .btn.btn-cons:focus, .btn.btnAdminManage:hover, .btn.btnAdminManage:focus {
	background-color: #3788d8 !important;
}

.btn-blockUser{
  color: #fff;
  background-color: #c0392b;
  border-color: #c0392b;
}

.form-group-2 input{
  font-size: 1em;
  width: 80%;
}

.col-form-label {
  margin-top: 8px;
}

.mt-3 {
  margin-left: 5px !important;
}

.itz-list-item {
  height: 50px;
  padding-left: 20px;
  padding-top: 7px;
  cursor:pointer;
}

.itz-list-item > span {
  left: 10px;
}

.itz-list-item > i.material-icons {
  color: #b6a8ab;
}

/* Small devices (tablets, 768px and up) */
@media (max-width: 768px) {
  div.content {
    margin-top: 46px;
  }

  table {
    border: 0 !important;
  }

  /* Search */
  .ui-tabview.ui-tabview-top .form-group {
    margin-bottom: 0;
  }
  .ui-tabview.ui-tabview-top .form-group .search-before {
    top: 10px;
    left: 18px;
    color: rgba(255,255,255,.2);
  }
  .ui-tabview.ui-tabview-top .form-group input#search {
    margin: 3px 8px 6px;
    width: calc(100% - 16px); /* margin 8px right + left */
    background: rgba(255,255,255,.05);
    color: #fff;
    box-shadow: none;
    font-weight: 300;
    transition: background .2s ease-in;
  }
  .ui-tabview.ui-tabview-top .form-group input#search:hover,
  .ui-tabview.ui-tabview-top .form-group input#search:focus {
    box-shadow: none;
    background: rgba(255,255,255,.15);
  }
  .ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch {
    top: 7px;
    right: 10px;
    color: #fff;
  }

  .mt-3 {
    margin-left: 1.25em !important;
  }

  .flex-container-bottom {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: stretch;
  }

  .flex-container-bottom > .flex-child {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: stretch;
    width: 90%;
    margin-left: 16px;
    font-size: 14px;
    margin-top: 0 !important;
  }

  .flex-container-bottom > .flex-child > label {
    font-size: 16px;
  }

  .flex-container-bottom > .flex-child > input, select {
    text-align: center;
  }

  select {
    z-index: 3;
  }

}

/* Checkbox and button styles */
.form-group {
  margin-bottom: 24px;
}

.form-group input[type="checkbox"] {
  margin-right: 10px;
}

.form-group label {
  display: inline-block;
  vertical-align: middle;
}

.form-group.text-center {
  margin-top: 24px;
}

/* Listing styles */
.itz-list {
  margin-top: 24px;
}

.itz-list-item {
  height: 50px;
  padding-left: 20px;
  padding-top: 15px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}

.itz-list-item > span {
  left: 10px;
}

.itz-list-item > i.material-icons {
  color: #b6a8ab;
}
body {
  font-family: 'Arial', sans-serif;
  background-color: #f4f6f9;
  color: #333;
}

/* Tabs */
.ui-tabview {
	padding: 0;
}
.ui-tabview .ui-tabview-panel {
	padding: 20px 0 0;
}
.ui-tabview.ui-tabview-top > .ui-tabview-nav {
	padding: 0;
	border-bottom: 1px solid rgba(0, 0, 0, 0.13);
}
.ui-tabview.ui-tabview-top > .ui-tabview-nav li {
	margin: 0;
	padding: 3px 0;
	font-size: 14px;
}
.ui-tabview .ui-tabview-nav li a {
	color: rgba(0, 0, 0, 0.54);
	text-transform: uppercase;
	font-weight: 500;
	line-height: 25px;
	font-size: 13px;
}
.ui-tabview .ui-tabview-nav li.ui-tabview-selected a,
.ui-tabview .ui-tabview-nav li.ui-state-disabled a,
.ui-tabview .ui-tabview-nav li.ui-state-processing a {
	color: #0077B5;
	cursor: default;
}
.ui-tabview .ui-tabview-nav li.ui-state-disabled a {
	color: rgba(0, 0, 0, 0.54);
}
.ui-tabview .ui-tabview-nav li.ui-tabview-selected {
	border-bottom: 3px solid #0077B5;
}

.ui-tabview.ui-tabview-top > .ui-tabview-nav li {
	top: 0;
}

/* Search */
.ui-tabview.ui-tabview-top .form-group.search {
	margin-bottom: 24px;
}
.ui-tabview.ui-tabview-top .form-group .search-before {
	position: absolute;
	color: #9f9f9f;
	top: 7px;
	left: 10px;
}
.ui-tabview.ui-tabview-top .form-group input#search {
	background: #fff;
	border-radius: 2px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
	padding: 6px 40px 6px 45px;
	transition: box-shadow .2s ease-out;
}
.ui-tabview.ui-tabview-top .form-group input#search:hover,
.ui-tabview.ui-tabview-top .form-group input#search:focus {
	box-shadow: 0 7px 14px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22);
}
.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch {
	position: absolute;
    top: 4px;
    right: 2px;
    margin: 0;
    font-size: 21px;
    padding: 0px;
	color: #9f9f9f;
}
.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch:hover {
	text-decoration: none;
}
.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch i {
	top: 0;
}

/* Small devices (tablets, 768px and up) */
@media (max-width: 768px) {
  /* Search */
  .ui-tabview.ui-tabview-top .form-group {
    margin-bottom: 0;
  }
  .ui-tabview.ui-tabview-top .form-group .search-before {
    top: 10px;
    left: 18px;
    color: rgba(255,255,255,.2);
  }
  .ui-tabview.ui-tabview-top .form-group input#search {
    margin: 3px 8px 6px;
    width: calc(100% - 16px); /* margin 8px right + left */
    background: rgba(255,255,255,.05);
    color: #fff;
    box-shadow: none;
    font-weight: 300;
    transition: background .2s ease-in;
  }
  .ui-tabview.ui-tabview-top .form-group input#search:hover,
  .ui-tabview.ui-tabview-top .form-group input#search:focus {
    box-shadow: none;
    background: rgba(255,255,255,.15);
  }
  .ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch {
    top: 7px;
    right: 10px;
    color: #fff;
  }
}

/* Search bar styles */
.professional-search-bar {
  position: relative;
  display: flex;
  align-items: center;
}

.professional-search-input {
  padding: 10px 45px 10px 15px;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
  width: 300px; /* Ajuster la largeur selon vos besoins */
}

.professional-search-input:focus {
  border-color: #0077B5;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}


.professional-reset-button {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 20px;
}

.professional-reset-button:hover {
  color: #555;
}

/* Checkbox and button styles */
.professional-checkbox {
  margin-left: 5px;
  margin-right: 10px;
}

.professional-checkbox-label {
  font-size: 16px;
}

.professional-button-group {
  margin-top: 20px;
}

/* Create button styles */
.professional-create-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: inline-block;
  width: 80px;
  height: 80px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  background-color: #0077B5;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.professional-create-button:hover {
  background-color: #005fa3;
  transform: scale(1.1);
}

/* Listing styles */
.professional-itz-list {
  margin-top: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.professional-itz-list-item {
  padding: 15px 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.professional-itz-list-item:nth-child(even) {
  background-color: #e8f4fc; /* Light blue */
}

.professional-itz-list-item:nth-child(odd) {
  background-color: #ffffff; /* White */
}

.professional-itz-list-item:hover {
  background-color: #f9f9f9;
}

.professional-itz-list-item > span {
  font-size: 16px;
}

.professional-itz-list-item > i.material-icons {
  float: right;
  color: #b6a8ab;
}

button i.material-icons.size-xxl {
  font-size: calc(2em + 1px);
  margin-top: -0.125em;
}
`, "",{"version":3,"sources":["webpack://./src/app/Components/UsersAdministration/usersAdministration.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8GAA8G;EAC9G,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAElB,+EAA+E;EAC/E,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAElB,+EAA+E;EAC/E,2BAA2B;EAC3B,YAAY;EACZ,WAAW,EAAE,kEAAkE;AACjF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,WAAW,EAAE,mCAAmC;EAChD,aAAa,EAAE,6CAA6C;EAC5D,eAAe,EAAE,+BAA+B;AAClD;;AAEA,6CAA6C;AAC7C;EACE,aAAa,EAAE,wCAAwC;AACzD;AACA;EACE,aAAa,EAAE,uDAAuD;AACxE;;AAEA,sBAAsB;AACtB;EACE,eAAe,EAAE,+BAA+B;AAClD;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA,WAAW;EACX;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,mBAAmB;IACnB,wBAAwB,EAAE,4BAA4B;IACtD,iCAAiC;IACjC,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;EACpC;EACA;;IAEE,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,QAAQ;IACR,WAAW;IACX,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;AAEF;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,WAAW;AACb;;AAEA,SAAS;AACT;CACC,UAAU;AACX;AACA;CACC,iBAAiB;AAClB;AACA;CACC,UAAU;CACV,4CAA4C;AAC7C;AACA;CACC,SAAS;CACT,cAAc;CACd,eAAe;AAChB;AACA;CACC,0BAA0B;CAC1B,yBAAyB;CACzB,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;AACA;;;CAGC,cAAc;CACd,eAAe;AAChB;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,gCAAgC;AACjC;;AAEA;CACC,MAAM;AACP;;AAEA,WAAW;AACX;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,cAAc;CACd,QAAQ;CACR,UAAU;AACX;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kEAAkE;CAClE,0BAA0B;CAC1B,mCAAmC;AACpC;AACA;;CAEC,mEAAmE;AACpE;AACA;CACC,kBAAkB;IACf,QAAQ;IACR,UAAU;IACV,SAAS;IACT,eAAe;IACf,YAAY;CACf,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;CACC,MAAM;AACP;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX;IACE,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,mBAAmB;IACnB,wBAAwB,EAAE,4BAA4B;IACtD,iCAAiC;IACjC,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;EACpC;EACA;;IAEE,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,QAAQ;IACR,WAAW;IACX,WAAW;EACb;AACF;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;EACzC,yBAAyB;EACzB,YAAY,EAAE,yCAAyC;AACzD;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2DAA2D;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,eAAe;AAC5C;;AAEA;EACE,yBAAyB,EAAE,UAAU;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB","sourcesContent":[".flex-container {\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: space-evenly;\n}\n\n.flex-container-bottom {\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: space-evenly;\n}\n\n.flex-container-bottom > .flex-child > label{\n  margin-right: 5px;\n}\n\n.flex-child-long {\n  flex-grow: 12;\n}\n\n.flex-child-long > input {\n  width: 100%;\n}\n\n.modal-body {\n  background-color: #FFFFFF;\n}\n\n.p-tabview.ui-tabview-top .form-group.search {\n  margin-bottom: 24px;\n}\n\ninput::placeholder {\n  /*sets the line height to 3 times the font size. The line height is the vertical space between lines of text.*/\n  font: 1.5rem/3 sans-serif;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: calc(100% - 1rem);\n}\n\n.modal-content {\n  padding-top: 24px;\n  padding-right: 24px;\n  padding-bottom: 16px;\n  padding-left: 24px;\n  -webkit-box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);\n  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);\n  border-radius: 0 !important;\n  border: none;\n  width: 190%;\n  max-width: 10000px;\n}\n\n.modal-dialog {\n  width: 50%;\n  max-width: 60%;\n  margin: 1.75rem auto;\n}\n\n.modal-content {\n  padding-top: 24px;\n  padding-right: 24px;\n  padding-bottom: 16px;\n  padding-left: 24px;\n  -webkit-box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);\n  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);\n  border-radius: 0 !important;\n  border: none;\n  width: 100%; /* Assurez-vous que le contenu prend toute la largeur disponible */\n}\n\n.modal-body {\n  background-color: #FFFFFF;\n  padding-top: 24px;\n  padding-right: 24px;\n  padding-bottom: 16px;\n  padding-left: 24px;\n}\n\n.modal-header {\n  border-bottom: none;\n  padding-top: 24px;\n  padding-right: 24px;\n  padding-bottom: 0;\n  padding-left: 24px;\n}\n\n.modal-footer {\n  border-top: none;\n  padding: 7px;\n}\n\n.modal-footer button {\n  margin: 0;\n  padding-left: 16px;\n  padding-right: 16px;\n  width: auto;\n}\n\n.modal-footer button.pull-left {\n  padding-left: 5px;\n  padding-right: 5px;\n  position: relative;\n  left: -5px;\n}\n\n.modal-footer button + button {\n  margin-bottom: 16px;\n}\n\n.modal-body + .modal-footer {\n  padding-top: 0;\n}\n\n/* Style the select box */\nselect {\n  width: 100%; /* Make the select box full-width */\n  padding: 10px; /* Add padding for better touch interaction */\n  font-size: 16px; /* Adjust font size as needed */\n}\n\n/* Style the dropdown arrow icon (optional) */\nselect::-ms-expand {\n  display: none; /* Remove the default arrow icon in IE */\n}\nselect::-webkit-select-arrow {\n  display: none; /* Remove the default arrow icon in Chrome and Safari */\n}\n\n/* Style the options */\nselect option {\n  font-size: 14px; /* Adjust font size as needed */\n}\n\n/* Buttons */\n.btnAdminManage {\n  display: inline-block;\n  padding: 9px 12px;\n  padding-top: 7px;\n  margin-bottom: 0;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  background-color: #d1dade;\n  background-image: none !important;\n  border: none;\n  text-shadow: none;\n  box-shadow: none;\n  transition: all 0.12s linear 0s !important;\n  width: 100%;\n}\n\n.btn-raised {\n  margin-right: 5px;\n  min-width: 120px;\n  margin-bottom: 8px;\n}\n\n.btn.btn-save {\n  background-color: #4cae4c;\n  color: #ffffff;\n}\n\n.btn.btn-save:hover, .btn.btn-save:focus {\n\tbackground-color: #5cb85c;\n}\n\n.btn-cons, .btnAdminManage {\n  background-color: #0077B5;\n  color: #ffffff;\n}\n\n.btn.btn-cons:hover, .btn.btn-cons:focus, .btn.btnAdminManage:hover, .btn.btnAdminManage:focus {\n\tbackground-color: #3788d8 !important;\n}\n\n.btn-blockUser{\n  color: #fff;\n  background-color: #c0392b;\n  border-color: #c0392b;\n}\n\n.form-group-2 input{\n  font-size: 1em;\n  width: 80%;\n}\n\n.col-form-label {\n  margin-top: 8px;\n}\n\n.mt-3 {\n  margin-left: 5px !important;\n}\n\n.itz-list-item {\n  height: 50px;\n  padding-left: 20px;\n  padding-top: 7px;\n  cursor:pointer;\n}\n\n.itz-list-item > span {\n  left: 10px;\n}\n\n.itz-list-item > i.material-icons {\n  color: #b6a8ab;\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (max-width: 768px) {\n  div.content {\n    margin-top: 46px;\n  }\n\n  table {\n    border: 0 !important;\n  }\n\n  /* Search */\n  .ui-tabview.ui-tabview-top .form-group {\n    margin-bottom: 0;\n  }\n  .ui-tabview.ui-tabview-top .form-group .search-before {\n    top: 10px;\n    left: 18px;\n    color: rgba(255,255,255,.2);\n  }\n  .ui-tabview.ui-tabview-top .form-group input#search {\n    margin: 3px 8px 6px;\n    width: calc(100% - 16px); /* margin 8px right + left */\n    background: rgba(255,255,255,.05);\n    color: #fff;\n    box-shadow: none;\n    font-weight: 300;\n    transition: background .2s ease-in;\n  }\n  .ui-tabview.ui-tabview-top .form-group input#search:hover,\n  .ui-tabview.ui-tabview-top .form-group input#search:focus {\n    box-shadow: none;\n    background: rgba(255,255,255,.15);\n  }\n  .ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch {\n    top: 7px;\n    right: 10px;\n    color: #fff;\n  }\n\n  .mt-3 {\n    margin-left: 1.25em !important;\n  }\n\n  .flex-container-bottom {\n    display: flex;\n    flex-wrap: nowrap;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .flex-container-bottom > .flex-child {\n    display: flex;\n    flex-wrap: nowrap;\n    flex-direction: column;\n    align-items: stretch;\n    width: 90%;\n    margin-left: 16px;\n    font-size: 14px;\n    margin-top: 0 !important;\n  }\n\n  .flex-container-bottom > .flex-child > label {\n    font-size: 16px;\n  }\n\n  .flex-container-bottom > .flex-child > input, select {\n    text-align: center;\n  }\n\n  select {\n    z-index: 3;\n  }\n\n}\n\n/* Checkbox and button styles */\n.form-group {\n  margin-bottom: 24px;\n}\n\n.form-group input[type=\"checkbox\"] {\n  margin-right: 10px;\n}\n\n.form-group label {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.form-group.text-center {\n  margin-top: 24px;\n}\n\n/* Listing styles */\n.itz-list {\n  margin-top: 24px;\n}\n\n.itz-list-item {\n  height: 50px;\n  padding-left: 20px;\n  padding-top: 15px;\n  cursor: pointer;\n  border-bottom: 1px solid #eee;\n}\n\n.itz-list-item > span {\n  left: 10px;\n}\n\n.itz-list-item > i.material-icons {\n  color: #b6a8ab;\n}\nbody {\n  font-family: 'Arial', sans-serif;\n  background-color: #f4f6f9;\n  color: #333;\n}\n\n/* Tabs */\n.ui-tabview {\n\tpadding: 0;\n}\n.ui-tabview .ui-tabview-panel {\n\tpadding: 20px 0 0;\n}\n.ui-tabview.ui-tabview-top > .ui-tabview-nav {\n\tpadding: 0;\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.13);\n}\n.ui-tabview.ui-tabview-top > .ui-tabview-nav li {\n\tmargin: 0;\n\tpadding: 3px 0;\n\tfont-size: 14px;\n}\n.ui-tabview .ui-tabview-nav li a {\n\tcolor: rgba(0, 0, 0, 0.54);\n\ttext-transform: uppercase;\n\tfont-weight: 500;\n\tline-height: 25px;\n\tfont-size: 13px;\n}\n.ui-tabview .ui-tabview-nav li.ui-tabview-selected a,\n.ui-tabview .ui-tabview-nav li.ui-state-disabled a,\n.ui-tabview .ui-tabview-nav li.ui-state-processing a {\n\tcolor: #0077B5;\n\tcursor: default;\n}\n.ui-tabview .ui-tabview-nav li.ui-state-disabled a {\n\tcolor: rgba(0, 0, 0, 0.54);\n}\n.ui-tabview .ui-tabview-nav li.ui-tabview-selected {\n\tborder-bottom: 3px solid #0077B5;\n}\n\n.ui-tabview.ui-tabview-top > .ui-tabview-nav li {\n\ttop: 0;\n}\n\n/* Search */\n.ui-tabview.ui-tabview-top .form-group.search {\n\tmargin-bottom: 24px;\n}\n.ui-tabview.ui-tabview-top .form-group .search-before {\n\tposition: absolute;\n\tcolor: #9f9f9f;\n\ttop: 7px;\n\tleft: 10px;\n}\n.ui-tabview.ui-tabview-top .form-group input#search {\n\tbackground: #fff;\n\tborder-radius: 2px;\n\tbox-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n\tpadding: 6px 40px 6px 45px;\n\ttransition: box-shadow .2s ease-out;\n}\n.ui-tabview.ui-tabview-top .form-group input#search:hover,\n.ui-tabview.ui-tabview-top .form-group input#search:focus {\n\tbox-shadow: 0 7px 14px rgba(0,0,0,0.25), 0 5px 5px rgba(0,0,0,0.22);\n}\n.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch {\n\tposition: absolute;\n    top: 4px;\n    right: 2px;\n    margin: 0;\n    font-size: 21px;\n    padding: 0px;\n\tcolor: #9f9f9f;\n}\n.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch:hover {\n\ttext-decoration: none;\n}\n.ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch i {\n\ttop: 0;\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (max-width: 768px) {\n  /* Search */\n  .ui-tabview.ui-tabview-top .form-group {\n    margin-bottom: 0;\n  }\n  .ui-tabview.ui-tabview-top .form-group .search-before {\n    top: 10px;\n    left: 18px;\n    color: rgba(255,255,255,.2);\n  }\n  .ui-tabview.ui-tabview-top .form-group input#search {\n    margin: 3px 8px 6px;\n    width: calc(100% - 16px); /* margin 8px right + left */\n    background: rgba(255,255,255,.05);\n    color: #fff;\n    box-shadow: none;\n    font-weight: 300;\n    transition: background .2s ease-in;\n  }\n  .ui-tabview.ui-tabview-top .form-group input#search:hover,\n  .ui-tabview.ui-tabview-top .form-group input#search:focus {\n    box-shadow: none;\n    background: rgba(255,255,255,.15);\n  }\n  .ui-tabview.ui-tabview-top .form-group input#search + button#resetSearch {\n    top: 7px;\n    right: 10px;\n    color: #fff;\n  }\n}\n\n/* Search bar styles */\n.professional-search-bar {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.professional-search-input {\n  padding: 10px 45px 10px 15px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n  transition: all 0.3s ease;\n  width: 300px; /* Ajuster la largeur selon vos besoins */\n}\n\n.professional-search-input:focus {\n  border-color: #0077B5;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n\n.professional-reset-button {\n  position: absolute;\n  right: 10px;\n  background: none;\n  border: none;\n  color: #999;\n  cursor: pointer;\n  font-size: 20px;\n}\n\n.professional-reset-button:hover {\n  color: #555;\n}\n\n/* Checkbox and button styles */\n.professional-checkbox {\n  margin-left: 5px;\n  margin-right: 10px;\n}\n\n.professional-checkbox-label {\n  font-size: 16px;\n}\n\n.professional-button-group {\n  margin-top: 20px;\n}\n\n/* Create button styles */\n.professional-create-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n  font-size: 18px;\n  font-weight: bold;\n  color: #fff;\n  background-color: #0077B5;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.professional-create-button:hover {\n  background-color: #005fa3;\n  transform: scale(1.1);\n}\n\n/* Listing styles */\n.professional-itz-list {\n  margin-top: 20px;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n}\n\n.professional-itz-list-item {\n  padding: 15px 20px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.professional-itz-list-item:nth-child(even) {\n  background-color: #e8f4fc; /* Light blue */\n}\n\n.professional-itz-list-item:nth-child(odd) {\n  background-color: #ffffff; /* White */\n}\n\n.professional-itz-list-item:hover {\n  background-color: #f9f9f9;\n}\n\n.professional-itz-list-item > span {\n  font-size: 16px;\n}\n\n.professional-itz-list-item > i.material-icons {\n  float: right;\n  color: #b6a8ab;\n}\n\nbutton i.material-icons.size-xxl {\n  font-size: calc(2em + 1px);\n  margin-top: -0.125em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
